import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'

import DeleteModal from 'pages/parts/DeleteModal'
import { httpOk, DELETE, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()
	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({
		"name": "",
		"days": [],
	})
	const [showModal, setShowModal] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function searchWithFilter() {
		var filterUrl = "/price-periods"

		const response = await GET(filterUrl, {}, { loader: true })
		if (!httpOk(response)) return

		// После перезагрузки списка оставляем раскрытым тот же период,
		// иначе таблица интервалов справа схлопывается на каждое сохранение
		var activeId = data?.data?.find(item => item.active)?.id
		if (activeId) {
			for (let i = 0; i < response.data.data.length; i++) {
				response.data.data[i]['active'] = response.data.data[i]['id'] === activeId
			}
		}

		setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var selectedItemCopy = { ...selectedItem }

		var response
		if (!selectedItemCopy.id) {
			response = await POST('/price-periods', selectedItemCopy, { loader: true })
		} else {
			response = await PUT('/price-periods', selectedItemCopy, { loader: true })
		}

		if (httpOk(response)) {
			toggleModal()
			searchWithFilter()
		}
	}

	function handleSelectItem(index) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy['data'].length; i++) {
			dataCopy['data'][i]['active'] = false
		}

		dataCopy['data'][index]['active'] = true
		setData(dataCopy)
	}

	async function deleteItem() {
		const response = await DELETE(`/price-periods/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	function handleChangeTime(e, index, type) {
		var selectedItemCopy = { ...selectedItem }

		if (type === 'start_time') {
			selectedItemCopy.days[index]['start_time'] = e.target.value
		}
		if (type === 'end_time') {
			selectedItemCopy.days[index]['end_time'] = e.target.value
		}

		setSelectedItem(selectedItemCopy)
	}

	function setDayStatus(index, key) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.days[index][key] = !selectedItemCopy.days[index][key]

		setSelectedItem(selectedItemCopy)
	}

	function addTime() {
		var selectedItemCopy = { ...selectedItem }
		var item = {
			"start_time": "",
			"end_time": "",
			"day1": false,
			"day2": false,
			"day3": false,
			"day4": false,
			"day5": false,
			"day6": false,
			"day7": false,
		}
		selectedItemCopy.days.push(item)

		setSelectedItem(selectedItemCopy)
	}

	async function deleteDay(item, index) {
		var selectedItemCopy = { ...selectedItem }

		if (!item.id) selectedItemCopy.days.splice(index, 1)

		if (item.id) {
			const response = await DELETE(`/price-periods/day/${item.id}`, {}, { loader: true })
			if (!httpOk(response)) return

			selectedItemCopy.days.splice(index, 1)
			searchWithFilter() // чтобы таблица справа не показывала удалённый интервал
		}

		setSelectedItem(selectedItemCopy)
	}

	function toggleModal(bool, item = { 'days': [] }) {
		setSelectedItem(JSON.parse(JSON.stringify(item)))
		setShowModal(bool)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('price_periods')}
				</h4>
				<div className="d-flex gap-2">
					<button className="btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-4 border-right">
							<div className="table-responsive">
								<table className="table table-bordered table-hover mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '50%' }}>{t('name2')}</th>
											<th style={{ 'width': '50%' }}></th>
											<th style={{ 'minWidth': '33px' }}></th>
										</tr>
									</thead>
									<tbody>
										{data?.data?.map((item, index) => (
											<tr key={index} className={`cursor ${item.active ? 'table-tr-active' : ''}`}>
												<td className="text-center" title={item.id}
													onClick={() => handleSelectItem(index)}>
													{index + 1}
												</td>
												<td onClick={() => handleSelectItem(index)}>
													{item.name}
												</td>
												<td onClick={() => handleSelectItem(index)}></td>
												<td>
													<div className="table-dropdown">
														<Dropdown id={`dropdown-${index}`}>
															<Dropdown.Toggle variant="outline-primary">
																<i className="uil uil-ellipsis-v"></i>
															</Dropdown.Toggle>

															<Dropdown.Menu>
																<div className="table-dropdown-item"
																	onClick={() => toggleModal(true, item)}>
																	<i className="uil-edit-alt"></i>
																	{t('edit')}
																</div>
																<div className="table-dropdown-item text-danger"
																	onClick={() => {
																		setDeleteModalParams({ id: item.id, index: index });
																		setModalDelete(true)
																	}}>
																	<i className="uil-times"></i>
																	{t('delete')}
																</div>
															</Dropdown.Menu>
														</Dropdown>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-md-8">
							<div className="table-responsive">
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'width': '80px' }}>{t('start')}</th>
											<th style={{ 'width': '80px' }}>{t('end')}</th>
											<th style={{ 'width': '50px' }}>{t('monday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('tuesday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('wednesday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('thursday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('friday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('saturday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('sunday_short')}</th>
										</tr>
									</thead>
									<tbody>
										{data?.data
											?.find(item => item.active === true) // берём только активный объект
											?.days?.map((item, index) => (
												<tr key={index}>
													<td className="td-input" style={{ 'width': '80px' }}>
														<input type="time"
															className="form-control"
															disabled
															value={item.start_time ?? ''}
															onChange={(e) => handleChangeTime(e, index, 'start_time')} />
													</td>
													<td className="td-input" style={{ 'width': '80px' }}>
														<input type="time"
															className="form-control"
															disabled
															value={item.end_time ?? ''}
															onChange={(e) => handleChangeTime(e, index, 'end_time')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day1 ?? false}
															onChange={() => setDayStatus(index, 'day1')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day2 ?? false}
															onChange={() => setDayStatus(index, 'day2')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day3 ?? false}
															onChange={() => setDayStatus(index, 'day3')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day4 ?? false}
															onChange={() => setDayStatus(index, 'day4')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day5 ?? false}
															onChange={() => setDayStatus(index, 'day5')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day6 ?? false}
															onChange={() => setDayStatus(index, 'day6')} />
													</td>
													<td className="vertical-middle">
														<input type="checkbox" className="form-check-input"
															disabled
															checked={item.day7 ?? false}
															onChange={() => setDayStatus(index, 'day7')} />
													</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* MODAL CREATE */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem?.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group w-100">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<div className="d-flex gap-2 mb-2">
								<h4 className="fw-600">{t('period_day_time')}</h4>
								<div className="table-action-button table-action-primary-button"
									onClick={() => addTime()}>
									<i className="uil-plus"></i>
								</div>
							</div>
							<div className="table-responsive">
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'width': '80px' }}>{t('start')}</th>
											<th style={{ 'width': '80px' }}>{t('end')}</th>
											<th style={{ 'width': '50px' }}>{t('monday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('tuesday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('wednesday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('thursday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('friday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('saturday_short')}</th>
											<th style={{ 'width': '50px' }}>{t('sunday_short')}</th>
											<th style={{ 'width': '50px' }}></th>
										</tr>
									</thead>
									<tbody>
										{selectedItem?.days?.map((item, index) => (
											<tr key={index}>
												<td className="td-input" style={{ 'width': '80px' }}>
													<input type="time"
														className="form-control"
														value={item.start_time ?? ''}
														onChange={(e) => handleChangeTime(e, index, 'start_time')} />
												</td>
												<td className="td-input" style={{ 'width': '80px' }}>
													<input type="time"
														className="form-control"
														value={item.end_time ?? ''}
														onChange={(e) => handleChangeTime(e, index, 'end_time')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day1 ?? false}
														onChange={() => setDayStatus(index, 'day1')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day2 ?? false}
														onChange={() => setDayStatus(index, 'day2')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day3 ?? false}
														onChange={() => setDayStatus(index, 'day3')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day4 ?? false}
														onChange={() => setDayStatus(index, 'day4')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day5 ?? false}
														onChange={() => setDayStatus(index, 'day5')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day6 ?? false}
														onChange={() => setDayStatus(index, 'day6')} />
												</td>
												<td className="vertical-middle">
													<input type="checkbox" className="form-check-input"
														checked={item.day7 ?? false}
														onChange={() => setDayStatus(index, 'day7')} />
												</td>
												<td>
													<div className="d-flex justify-content-center">
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteDay(item, index)}>
															<i className="uil-times"></i>
														</div>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!(selectedItem.name)}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index